

export class GymDepartmentModel {
    deptName: string;
    deptCode: string;
    deptId: string;
    
    constructor(deptName: string, deptCode: string, deptId: string) {
        this.deptCode = deptCode;
        this.deptId = deptId;
        this.deptName = deptName;
    }
}
